import { inject, OnInit, Pipe, PipeTransform } from '@angular/core';
import { AppdataService } from '../service/appdata.service';
@Pipe({
    name: 'getCompanytypeById',
    standalone: false
})
export class GetCompanytypeByIdPipe implements PipeTransform {

    dataService = inject(AppdataService);


    transform(id: string): string {
        let types = this.dataService.companyTypes.getValue();
        let result = types.find(type => type.id === id)?.name || "";
        return result;
    }

}
